import React from "react";
import Typography from "@material-ui/core/Typography";
import { CssBaseline } from "@material-ui/core";
import HomePageBanner from "./banner1.gif";
import "./styles.scss";

const HomePage = () => {
  return (
    <div className="homepage-container">
      <div>
        <Typography
          component="h1"
          variant="h2"
          style={{ color: "var(--default-green)" }}
        >
          Welcome To
        </Typography>
        <CssBaseline />
        <Typography
          component="h1"
          variant="h1"
          style={{ color: "var(--default-green)" }}
        >
          ITSM
        </Typography>
      </div>
      <div>
        <img src={HomePageBanner} height="450px" alt="img"/>
      </div>
    </div>
  );
};

export default HomePage;
